import React, { useState, useEffect } from 'react';
import { api } from '@/api';
import { resolveMediaUrl } from '@/utils/helpers';

export const PageHeroBanner = ({ pageSlug, fallbackTitle, fallbackSubtitle }) => {
  const [banner, setBanner] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBanner = async () => {
      try {
        const res = await api.getPageBanner(pageSlug);
        setBanner(res.data);
      } catch (error) {
        // Banner not found, use fallback
        setBanner(null);
      } finally {
        setLoading(false);
      }
    };
    loadBanner();
  }, [pageSlug]);

  // Don't render anything if no image is set
  if (loading) return null;
  if (!banner?.hero_image) return null;

  return (
    <div className="relative w-full" style={{ marginTop: '40px' }}>
      <div className="max-w-7xl mx-auto px-4">
        <div className="relative rounded-2xl overflow-hidden" style={{ height: '448px' }}>
          {/* Background Image */}
          <img 
            src={resolveMediaUrl(banner.hero_image)} 
            alt={banner.hero_title || fallbackTitle || ''} 
            className="absolute inset-0 w-full h-full"
            style={{ 
              objectFit: 'cover',
              objectPosition: `${banner.image_position_x ?? 50}% ${banner.image_position_y ?? 50}%`,
              transform: `scale(${(banner.image_zoom ?? 100) / 100})`,
              transformOrigin: `${banner.image_position_x ?? 50}% ${banner.image_position_y ?? 50}%`
            }}
          />
          {/* Dark Overlay */}
          <div 
            className="absolute inset-0 bg-black" 
            style={{ opacity: banner.overlay_opacity || 0.5 }}
          />
          {/* Content */}
          {(banner.hero_title || banner.hero_subtitle || fallbackTitle) && (
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-8">
              {(banner.hero_title || fallbackTitle) && (
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-3">
                  {banner.hero_title || fallbackTitle}
                </h1>
              )}
              {(banner.hero_subtitle || fallbackSubtitle) && (
                <p className="text-lg md:text-xl text-gray-200 max-w-2xl">
                  {banner.hero_subtitle || fallbackSubtitle}
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeroBanner;
